import { useLocalStorage } from '@vueuse/core';
export const defaultSafetyAppearancePreferences = Object.freeze({
    showImages: false,
    hideND: true,
    profile: null,
});
const LEGACY_VUEX_STORAGE_KEY = 'vuex';
const SAFETY_APPEARANCE_STORAGE_KEY = 'safety.appearance';
const migrateLegacySafetyAppearance = () => {
    if (typeof window === 'undefined' || typeof window.localStorage === 'undefined')
        return;
    try {
        const rawLegacyStore = window.localStorage.getItem(LEGACY_VUEX_STORAGE_KEY);
        if (!rawLegacyStore)
            return;
        const parsedLegacyStore = JSON.parse(rawLegacyStore);
        const legacySafety = parsedLegacyStore?.safety;
        if (!legacySafety || !('stateSafetyOptions' in legacySafety))
            return;
        const legacyOptions = legacySafety.stateSafetyOptions;
        const rawAppearance = window.localStorage.getItem(SAFETY_APPEARANCE_STORAGE_KEY);
        const appearance = rawAppearance ? JSON.parse(rawAppearance) : {};
        const migratedAppearance = { ...appearance };
        if (legacyOptions && !('showImages' in migratedAppearance) && typeof legacyOptions.showImages === 'boolean') {
            migratedAppearance.showImages = legacyOptions.showImages;
        }
        if (legacyOptions && !('hideND' in migratedAppearance)) {
            if (typeof legacyOptions.hideND === 'boolean') {
                migratedAppearance.hideND = legacyOptions.hideND;
            }
            else if (typeof legacyOptions.hideChemicalsWithNoSafety === 'boolean') {
                migratedAppearance.hideND = legacyOptions.hideChemicalsWithNoSafety;
            }
        }
        if (legacyOptions &&
            !('profile' in migratedAppearance) &&
            (typeof legacyOptions.profile === 'string' ||
                typeof legacyOptions.profile === 'number' ||
                legacyOptions.profile === null)) {
            migratedAppearance.profile = legacyOptions.profile;
        }
        if (Object.keys(migratedAppearance).length > Object.keys(appearance).length) {
            window.localStorage.setItem(SAFETY_APPEARANCE_STORAGE_KEY, JSON.stringify(migratedAppearance));
        }
        const nextLegacySafety = { ...legacySafety };
        delete nextLegacySafety.stateSafetyOptions;
        window.localStorage.setItem(LEGACY_VUEX_STORAGE_KEY, JSON.stringify({
            ...parsedLegacyStore,
            safety: nextLegacySafety,
        }));
    }
    catch {
        // Keep defaults when storage is unavailable or contains invalid data.
    }
};
migrateLegacySafetyAppearance();
export const safetyAppearancePreference = useLocalStorage(SAFETY_APPEARANCE_STORAGE_KEY, { ...defaultSafetyAppearancePreferences }, { mergeDefaults: true });
